import { type ChatMessageModel } from '@/shared/api'

export const getTextMessagePreview = (message: ChatMessageModel) => {
  const text = message.text
    ? message.text
    : message.attachment
      ? 'Отправлен файл'
      : ''
  return message.isCurrentUserMessage ? `Вы: ${text}` : text
}
